/* eslint-disable */
(function verticalFilter($, Drupal) {
  // Drupal.behaviors.verticalFilter = {
  //   attach(context) {

      const iconWrapper = `<span class="fa fa-plus vertical-filter__item-icon"></span>`;

      // Add icon to each fieldgroup
      $('.fieldgroup').each(function() {
        $(this).find('.fieldset__legend').append(iconWrapper);

        // We hide them all as a defualt.
        $(this).find('.fieldset__content').hide();

        // Go through all and see if there is a checked box.
        $(this).find('.form-checkbox').each(function() {

          // If checked show the content well & update icon.
          if($(this).is(':checked')) {
            $(this).closest('fieldset').find('.fieldset__content').show();
            $(this).closest('fieldset').find('.vertical-filter__item-icon').removeClass('fa-plus');
            $(this).closest('fieldset').find('.vertical-filter__item-icon').addClass('fa-minus');
          }

        })

      });

      // On click of icon, show/hide list / change icon.
      $('.vertical-filter__item-icon, .fieldset__legend-label').on('click', function() {

        $(this).closest('fieldset').find('.fieldset__content').slideToggle();

        // In the case of user clicking label we need to adjust the logic a bit.
        let toggleIcon = '';
        if ($(this).hasClass('fieldset__legend-label')) {
          toggleIcon = $(this).next();
        } else {
          toggleIcon = $(this);
        }
        
        // Add condition to check if lable is clicked as well.
        // Check if user clicked plus/minus icon
        if (toggleIcon.hasClass('fa-plus')) {
          toggleIcon.removeClass('fa-plus');
          toggleIcon.addClass('fa-minus');
        } else {
          toggleIcon.removeClass('fa-minus');
          toggleIcon.addClass('fa-plus');
        }
      })

      // const initDropdown = (state) => {
      //   const iconWrapper = `<span class="fa fa-${state} vertical-filter__item-icon"></span>`;

      //   // Add icon to the filter menu section
      //   $(context).once('addToggleIcon').find('.vertical-filter__item-group').each(function () {
      //     $(this).find('.fieldset__legend').append($(iconWrapper));
      //   });
      // };

      // $('.vertical-filter', context).children('.vertical-filter__item-group').each(function () {
      //   let state;
      //   const wrapper = $(this).find('.fieldset').find('.fieldset__content');
      //   const checked = wrapper.find(':checked');

      //   // Set the state of the filter menu.
      //   // Check if the filter criteria has been selected. If so, set the toggle state as `open`.
      //   if (checked.length > 0) {
      //     state = 'minus';
      //   }
      //   else {
      //     state = 'plus';
      //     wrapper.hide();
      //   }

      //   initDropdown(state);
      // });

      // $('.vertical-filter__item-icon', context).once().click(function () {
      //   $(this).closest('.fieldset').find('.fieldset__content').slideToggle();

      //   let nextState;

      //   // Toggle the filter icon when `.fieldset__content` is open/closed.
      //   if ($(this).hasClass('fa-minus')) {
      //     nextState = 'plus';
      //   }
      //   else if ($(this).hasClass('fa-plus')) {
      //     nextState = 'minus';
      //   }
      //   else {
      //     // Setting a default state, just in case...
      //     nextState = 'plus';
      //   }

      //   $(this).attr('class', `fa fa-${nextState} vertical-filter__item-icon`);
      // });

      // // Open the Filter Menu when you click on the label
      // $('.fieldset__legend-label', context).once().click(function () {
      //   $(this).closest('.fieldset').find('.fieldset__content').slideToggle();

      //   const nextIcon = $(this).closest('.fieldset').find('.vertical-filter__item-icon');
      //   let nextState;

      //   // Toggle the filter icon when `.fieldset__content` is open/closed.
      //   if (nextIcon.hasClass('fa-minus')) {
      //     nextState = 'plus';
      //   }
      //   else if (nextIcon.hasClass('fa-plus')) {
      //     nextState = 'minus';
      //   }
      //   else {
      //     // Setting a default state, just in case...
      //     nextState = 'plus';
      //   }

      //   nextIcon.attr('class', `fa fa-${nextState} vertical-filter__item-icon`);
      // });
  //   },
  // };
}(jQuery, Drupal));
/* eslint-enable */
